import React from 'react'
import './Activity.scss'

function Activity() {
  return (
    <div>Activity</div>
  )
}

export default Activity